var map = {
	"./Article": 89061,
	"./Article/": 89061,
	"./Article/index": 89061,
	"./Article/index.jsx": 89061,
	"./Article/styles.module.css": 50574,
	"./ArticleLoopLayout": 95651,
	"./ArticleLoopLayout/": 95651,
	"./ArticleLoopLayout/index": 95651,
	"./ArticleLoopLayout/index.jsx": 95651,
	"./ArticleLoopLayout/styles.module.css": 84944,
	"./FooterLayout": 8147,
	"./FooterLayout/": 8147,
	"./FooterLayout/index": 8147,
	"./FooterLayout/index.jsx": 8147,
	"./FooterLayout/styles.module.css": 42113,
	"./QuoteLayout": 31419,
	"./QuoteLayout/": 31419,
	"./QuoteLayout/index": 31419,
	"./QuoteLayout/index.jsx": 31419,
	"./QuoteLayout/styles.module.css": 54358,
	"./StoryLayout": 7103,
	"./StoryLayout/": 7103,
	"./StoryLayout/index": 7103,
	"./StoryLayout/index.jsx": 7103,
	"./StoryLayout/styles.module.css": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;